import type { Nft, TraitWithRarity } from "@anaconda/core/nft/types"
import { Trait, TraitSkeleton } from "./trait"

interface Props {
  traits: TraitWithRarity[]
  nft: Nft
}

export function NftTraits(props: Props) {
  return (
    <TraitsLayout>
      {props.traits.map((trait) => (
        <Trait
          key={trait.key}
          trait={trait}
          collectionId={props.nft.collection.id}
        />
      ))}
    </TraitsLayout>
  )
}

const PLACEHOLDERS = Array.from({ length: 6 }).map((_, idx) => idx)

export function TraitSkeletons() {
  return (
    <TraitsLayout>
      {PLACEHOLDERS.map((id) => (
        <TraitSkeleton key={id} />
      ))}
    </TraitsLayout>
  )
}

function TraitsLayout(props: { children: React.ReactNode }) {
  return (
    <div className="grid max-h-[248px] grid-cols-2 gap-[10px] overflow-auto">
      {props.children}
    </div>
  )
}
